export class VehicleInspectionTypeQueryParameters {
  expired?: boolean;
  fuelType?: string;
  id?: number;
  isDefaultInspection?: boolean;
  oemId?: string;
  page?: number;
  pageSize?: number;

  constructor(obj?: VehicleInspectionTypeQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
